module.exports = {
	"id": "HU",
	"name": "Hungary",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.032072,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.008018,
			"12": 0.016036,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.008018,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.032072,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.024054,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.024054,
			"32": null,
			"33": 0.016036,
			"34": 0.04009,
			"35": 0.016036,
			"36": 0.008018,
			"37": 0.032072,
			"38": 0.024054,
			"39": 0.064144,
			"40": 0.024054,
			"41": 0.008018,
			"42": 0.016036,
			"43": 0.072162,
			"44": 0.032072,
			"45": 0.024054,
			"46": 0.024054,
			"47": 0.048108,
			"48": 0.072162,
			"49": 3.495848,
			"50": 4.698548,
			"51": 0.344774,
			"52": 0.272612,
			"53": 21.095358,
			"54": 5.676744,
			"55": 0.056126,
			"56": 0.016036,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.008018,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.016036,
			"13": null,
			"14": null,
			"15": 0.016036,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.008018,
			"29": null,
			"30": 0.016036,
			"31": 0.024054,
			"32": 0.008018,
			"33": 0.016036,
			"34": 0.016036,
			"35": 0.032072,
			"36": 0.016036,
			"37": 0.024054,
			"38": 0.08018,
			"39": 0.048108,
			"40": 0.04009,
			"41": 0.04009,
			"42": 0.04009,
			"43": 0.152342,
			"44": 5.668726,
			"45": 0.176396,
			"46": 9.517366,
			"47": 0.633422,
			"48": 0.673512,
			"49": 12.155288,
			"50": 0.032072,
			"51": null,
			"52": null,
			"3.5": 0.024054,
			"3.6": 0.032072
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.016036,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.008018,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.096216,
			"37": 0.04009,
			"38": 0.048108,
			"39": 0.016036,
			"40": 0.954142,
			"41": 0.168378,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.008018,
			"12.1": 5.668726
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.008018,
			"6": null,
			"7": 0.016036,
			"8": 0.048108,
			"9": 0.064144,
			"10": 0.513152,
			"3.1": null,
			"3.2": null,
			"5.1": 0.032072,
			"6.1": 0.016036,
			"7.1": null,
			"9.1": 0.264594
		},
		"ios_saf": {
			"8": 0,
			"10": 2.28569817985,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0615969211074,
			"8.1-8.4": 0.113797701707,
			"9.0-9.2": 0.0542888118235,
			"9.3": 0.828252385512
		},
		"android": {
			"3": 0,
			"4": 0.0231950335917,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00289937919897,
			"4.1": 0.0836677997416,
			"4.2-4.3": 0.209169499354,
			"4.4": 0.479640158915,
			"4.4.3-4.4.4": 0.483782129199
		},
		"ie": {
			"6": 0.00808146701847,
			"7": 0.00808146701847,
			"8": 0.161629340369,
			"9": 0.258606944591,
			"10": 0.113140538259,
			"11": 2.51333624274,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0446956558531,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00124154599592
		},
		"edge": {
			"12": 0.048108,
			"13": 0.264594,
			"14": 0.84189
		},
		"ie_mob": {
			"10": 0.179384957746,
			"11": 0.730353042254
		},
		"bb": {
			"7": 0.00991,
			"10": null
		},
		"samsung": {
			"0": 1.335868
		},
		"and_uc": {
			"0": 0.083244
		},
		"op_mini": {
			"0": 0.602176798151
		},
		"and_chr": {
			"0": 12.858844
		},
		"and_ff": {
			"0": 0.017838
		}
	},
	"total": 98.528738
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/HU.json
 ** module id = 546
 ** module chunks = 0
 **/